import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/img/nofile.svg';
const _hoisted_1 = { class: "flex items-center flex-col" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("img", {
    style: { "margin": "0 auto" },
    src: _imports_0,
    alt: ""
}, null, -1 /* HOISTED */);
import { UITextMdMedium } from '@gohighlevel/ghl-ui';
export default /*#__PURE__*/ _defineComponent({
    __name: 'NoFile',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createVNode(_unref(UITextMdMedium), null, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.nofile')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
